import React from 'react';

interface TextProps extends React.CSSProperties {
  children: React.ReactNode;
}

const Text: React.FC<TextProps> = ({ children, ...rest }) => {
  return <p style={{ ...rest }}>{children}</p>;
};

export default Text;
